<template>
  <div id="switch-metocean">
    <span v-for="(element,index) in elements"
           :key="index">
        <input 
          type="radio" 
          :id="element.value" 
          :value="element.value" 
          v-model="selectedElements"
        >
        <label :for="element.value">
          {{ element.label }}
        </label>
    </span>
  </div>
</template>

<script>
//Mixins
import {ColorMixin, MetoceanMixin} from "@/mixins";

export default {
  mixins: [ColorMixin, MetoceanMixin],

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#switch-metocean {
  background: $aisea-dark-gray;
  border-radius: 4px;

  input {
    display: none;
  }

  label {
    display: block;
    float: left;
    cursor: pointer;
    margin: 2px;
    border-radius: 4px;
    padding: 8px 12px;
    color: $aisea-black;
    text-align: center;
    line-height: 1;
    opacity: 1;
  }

  input[type="radio"]:checked + label {
    background-color: $aisea-blue;
    color:$aisea-white;
  }

}

</style>